import { GridOptions } from '@ag-grid-community/core';

import { TableConstants } from '@shared/constants/table.constants';

import { ProtocolEntryGridRow } from '../types/protocol-entry-grid-row';

export const PROTOCOL_ENTRY_DEFAULT_CONFIG: GridOptions<ProtocolEntryGridRow> = {
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
  },
  ...TableConstants.DEFAULT_GRID_OPTIONS.GRID_OPTIONS,
  enableRangeSelection: true,
  enterNavigatesVertically: true,
  enterNavigatesVerticallyAfterEdit: true,
  getRowId: ({ data }) => data?.patient_protocol_id || data?.randomID || '',
  rowDragManaged: true,
  suppressCellFocus: false,
  suppressMenuHide: true,
  undoRedoCellEditing: true,
  undoRedoCellEditingLimit: 20,
};
